import { toast } from "sonner";
import { t } from "@/lib/i18n";

// a07c — every buyer PDF download goes through here: a failed render shows the
// "could not be generated" message in the buyer's language, never a raw error page.
export async function downloadPdf(url, filename) {
  try {
    const r = await fetch(url, { credentials: "include" });
    if (!r.ok) {
      const body = await r.json().catch(() => ({}));
      toast.error(r.status === 503 ? t("pdf.unavailable") : (body.detail || t("pdf.download_failed")));
      return false;
    }
    const objectUrl = URL.createObjectURL(await r.blob());
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(objectUrl);
    return true;
  } catch {
    toast.error(t("pdf.download_failed"));
    return false;
  }
}
